import Basic from "./basic";

export default Basic;
